import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sectionsPanel", "settingsPanel", "sectionsTab", "settingsTab"]

  showSections() {
    this.sectionsPanelTarget.classList.remove("hidden")
    this.settingsPanelTarget.classList.add("hidden")
    this.sectionsTabTarget.classList.add("border-primary", "text-primary")
    this.sectionsTabTarget.classList.remove("border-transparent", "text-text-secondary")
    this.settingsTabTarget.classList.remove("border-primary", "text-primary")
    this.settingsTabTarget.classList.add("border-transparent", "text-text-secondary")
  }

  showSettings() {
    this.settingsPanelTarget.classList.remove("hidden")
    this.sectionsPanelTarget.classList.add("hidden")
    this.settingsTabTarget.classList.add("border-primary", "text-primary")
    this.settingsTabTarget.classList.remove("border-transparent", "text-text-secondary")
    this.sectionsTabTarget.classList.remove("border-primary", "text-primary")
    this.sectionsTabTarget.classList.add("border-transparent", "text-text-secondary")
  }
}
